import React, { createContext, PropsWithChildren, useContext } from 'react'
import useTPPChangeLogModal from './hooks/useTPPChangeLogModal'
import TPPChangeLogModal from './TPPChangeLogModal'
import { GroupedChange } from './types'

const TPPChangeLogModalContext = createContext<ReturnType<typeof useTPPChangeLogModal> | undefined>(undefined)

interface TPPChangeLogModalProviderProps {
    mockData?: GroupedChange[]
}

const TPPChangeLogModalProvider = ({ children, mockData }: PropsWithChildren<TPPChangeLogModalProviderProps>) => {
    const changeLogModal = useTPPChangeLogModal()

    return (
        <TPPChangeLogModalContext.Provider value={changeLogModal}>
            <TPPChangeLogModal mockData={mockData} />
            {children}
        </TPPChangeLogModalContext.Provider>
    )
}

export const useTPPChangeLogModalContext = () => {
    const context = useContext(TPPChangeLogModalContext)

    if (!context) {
        throw new Error('useTPPChangeLogModalContext must be used within TPPChangeLogModalProvider')
    }

    return context
}

export default TPPChangeLogModalProvider
